import { isOwned } from '@tunasong/models'
import { useSelector } from '@tunasong/redux'
import { isEntity } from '@tunasong/schemas'

export const useIsOwner = (item: unknown) => {
  const userId = useSelector(state => state.user.userId)
  return Boolean(isEntity(item) && isOwned(item) && item.userId === userId)
}
